// Premium semi-circle score gauge (SVG)
export const ScoreGauge = ({ score = 0, rating = '', size = 200 }) => {
  const clamped = Math.max(0, Math.min(100, score));
  const stroke = 16;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = Math.PI * r; // semi-circle
  const offset = circumference * (1 - clamped / 100);
  const color =
    clamped >= 85 ? '#0E9F6E' : clamped >= 70 ? 'var(--tenant-accent-500)' : clamped >= 50 ? '#F4A13A' : '#D64545';
  return (
    <div className="flex flex-col items-center" data-testid="objective-gauge">
      <svg width={size} height={size / 2 + 16} viewBox={`0 0 ${size} ${size / 2 + 16}`}>
        <path
          d={`M ${stroke / 2} ${cy} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${cy}`}
          fill="none" stroke="#EDEFF3" strokeWidth={stroke} strokeLinecap="round"
        />
        <path
          d={`M ${stroke / 2} ${cy} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${cy}`}
          fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 900ms cubic-bezier(0.2,0.8,0.2,1)' }}
        />
      </svg>
      <div className="-mt-[52px] flex flex-col items-center">
        <span className="font-display text-4xl font-bold tabular text-foreground" data-testid="score-value">{clamped}</span>
        <span className="text-xs text-muted-foreground">/ 100</span>
      </div>
      {rating && (
        <span className="mt-3 rounded-full px-3 py-1 text-xs font-semibold" style={{ backgroundColor: 'var(--tenant-accent-100)', color: 'var(--tenant-accent-600)' }}>
          {rating}
        </span>
      )}
    </div>
  );
};
